module.exports = __webpack_public_path__ + "static/media/start_icon.8b8c0ffa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start_icon.svg
// module id = 115
// module chunks = 0